import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Box, Button, Grid, IconButton, MenuItem, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import BasicDialog from "../../../components/base/BasicDialog";
import { useCreateProductTagMutation, useProductTags } from "../../../services/productsService";

export const AddTagDialog = (props) => {
    const { onClose, formTagIds, setFormTagIds } = props;
    const { t } = useTranslation();

    const [selectedTagId, setSelectedTagId] = useState(null);

    const handleConfirmChoice = () => {
        if (selectedTagId) {
            setFormTagIds([...formTagIds, selectedTagId]);
        }

        props.onClose();
    };

    return (
        <BasicDialog
            open={true}
            onClose={onClose}
            titleAlign={"center"}
            contentAlign={"center"}
            title={t("products.AddTagDialog.title")}
            maxWidth={"sm"}
            showDialogActions
            alwaysFullScreen={false}
            contentSx={{ pt: 0 }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 2,
                    margin: "1rem",
                    padding: "1rem",
                }}
            >
                <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    justifyContent="center"
                    width="100%"
                >
                    <Grid item xs={6}>
                        <Typography>{t("products.AddTagDialog.select")}</Typography>
                        <ProductTagDropdown
                            alreadySelectedTagIds={formTagIds}
                            onSelectTag={(tagId) => setSelectedTagId(tagId)}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography>{t("products.AddTagDialog.create")}</Typography>
                        <CreateTagControl />
                    </Grid>
                </Grid>
                <Button onClick={handleConfirmChoice} disabled={selectedTagId == null}>
                    {t("products.AddTagDialog.confirm")}
                </Button>
            </Box>
        </BasicDialog>
    );
};

export const ProductTagDropdown = (props) => {
    const { alreadySelectedTagIds, onSelectTag } = props;
    const { data: filteredTags } = useProductTags(new URLSearchParams(), {
        select: (allTags) => allTags.filter((tag) => !alreadySelectedTagIds.includes(tag.id)),
    });

    if (!filteredTags) {
        return null;
    }

    return (
        <TextField select fullWidth onChange={(e) => onSelectTag(e.target.value)}>
            {filteredTags.map((tag) => (
                <MenuItem key={tag.id} value={tag.id}>
                    {tag.tag_name}
                </MenuItem>
            ))}
        </TextField>
    );
};

export const CreateTagControl = (props) => {
    const [tagText, setTagText] = useState("");
    const isEmpty = tagText.trim().length === 0;

    const { mutate: createTag } = useCreateProductTagMutation();

    const handleCreateTag = () => {
        createTag({ tag_name: tagText.trim() });
        setTagText("");
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 1 }}>
            <TextField value={tagText} onChange={(e) => setTagText(e.target.value)} />
            <IconButton onClick={handleCreateTag} disabled={isEmpty}>
                <AddCircleIcon />
            </IconButton>
        </Box>
    );
};
